import { render, staticRenderFns } from "./fit-reisen-view.vue?vue&type=template&id=b6d725e6"
import script from "./fit-reisen-view.vue?vue&type=script&lang=js"
export * from "./fit-reisen-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports